// extracted by mini-css-extract-plugin
export default {"image":"Yea-z","loaded":"Zea-z"};